"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _services = require("../../services");
var _coreStarRatingInput = require("@vfuk/core-star-rating-input");
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SelectionDiv = (0, _styledComponents.default)('div')`
  display: flex;
  // background-color: white;
  border: 1px solid #bebebe;
  border-radius: 6px;
  padding: 16px;
`;
const SelectionWrapperDiv = (0, _styledComponents.default)('div')`
  display: flex;
  gap: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
const StarsAndFooterDiv = (0, _styledComponents.default)('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const TextDiv = (0, _styledComponents.default)('div')`
  font-size: 18px;
  font-weight: bold;
`;
const FooterDiv = (0, _styledComponents.default)('div')`
  display: flex;
  justify-content: space-between;
`;
const StarRatingInputWrapper = (0, _styledComponents.default)('div')`
  label {
    padding-right: ${props => props.padding || '15px'};
    padding-left: ${props => props.padding || '15px'};

    ${_r10SourceLibrary.Mixins.respondTo.lg`
      padding-right: 35px;
      padding-left: 35px;
    `}

    scale: ${props => props.scale || 1.4};
  }
`;
const RatingStars = _ref => {
  let {
    handleRatingClick,
    starsPadding,
    starsScale
  } = _ref;
  const text = _services.locale.localeString('Recommendation.StarRatingInput.text');
  const minText = _services.locale.localeString('Recommendation.StarRatingInput.minText');
  const maxText = _services.locale.localeString('Recommendation.StarRatingInput.maxText');
  return /*#__PURE__*/_react.default.createElement(SelectionDiv, {
    "data-testid": "star-rating-input-selection"
  }, /*#__PURE__*/_react.default.createElement(SelectionWrapperDiv, null, /*#__PURE__*/_react.default.createElement(TextDiv, null, text), /*#__PURE__*/_react.default.createElement(StarsAndFooterDiv, null, /*#__PURE__*/_react.default.createElement(StarRatingInputWrapper, {
    scale: starsScale,
    padding: starsPadding
  }, /*#__PURE__*/_react.default.createElement(_coreStarRatingInput.StarRatingInput, {
    name: "starRatingInput",
    value: 0,
    onChange: value => {
      handleRatingClick(value);
    }
  })), /*#__PURE__*/_react.default.createElement(FooterDiv, null, /*#__PURE__*/_react.default.createElement("span", null, minText), /*#__PURE__*/_react.default.createElement("span", null, maxText)))));
};
var _default = RatingStars;
exports.default = _default;